export const AdvancedSearch = {
  top: {
    id: 'div-gpt-ad-1500408303616-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerAdvancedSearch_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500408231516-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerAdvancedSearch_top_320x100',
  },
  bottom: {
    id: 'div-gpt-ad-1500408749417-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTrackerAdvancedSearch_top_300x250',
  },
};

export const ExtendedDetails = {
  top: {
    id: 'div-gpt-ad-1501016286376-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerExtendedDetails_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1501016286376-1',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerExtendedDetails_top_320x100',
  },
  left: {
    id: 'div-gpt-ad-1501016578088-1',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTrackerExtendedDetails_top_300x250',
  },
  right: {
    id: 'div-gpt-ad-1501016578088-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTrackerExtendedDetails_second_300x250',
  },
};

export const FlightTracker = {
  banner: {
    id: 'div-gpt-ad-1502745996964-1',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTracker_top_728x90',
  },
  bannerMobile: {
    id: 'div-gpt-ad-1502745996964-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTracker_top_320x100',
  },
  bottom: {
    id: 'div-gpt-ad-1470845574196-1',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTracker_Second_300x250',
  },
  bottomMobile: {
    id: 'div-gpt-ad-1499900382761-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTracker_Mobile_Map_300x250',
  },
  top: {
    id: 'div-gpt-ad-1470845574196-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTracker_top_300x250',
  },
  topMobile: {
    id: 'div-gpt-ad-1499900332724-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTracker_Mobile_Map_top_320x100',
  },
};

export const MultiFlight = {
  top: {
    id: 'div-gpt-ad-1500412152622-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerFlightPicker_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500412067268-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerFlightPicker_top_320x100',
  },
};

export const UnifiedSearch = {
  top: {
    id: 'div-gpt-ad-1500407967872-0',
    sizes: [728, 90],
    adSlot: '/1010197/BS_FlightTrackerSearch_top_728x90',
  },
  topMobile: {
    id: 'div-gpt-ad-1500408024011-0',
    sizes: [[320, 100], [320, 50]],
    adSlot: '/1010197/BS_FlightTrackerSearch_top_320x100',
  },
  bottom: {
    id: 'div-gpt-ad-1500408139456-0',
    sizes: [300, 250],
    adSlot: '/1010197/BS_FlightTrackerSearch_top_300x250',
  },
};

export const FullScreenMap = {
  id: 'div-gpt-ad-1500413150337-0',
  sizes: [728, 90],
  adSlot: '/1010197/BS_FlightTrackerFullMap_top_728x90',
};



// WEBPACK FOOTER //
// ./modules/FlightTracker/components/ads.js